import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { Orden } from 'src/app/ordenes/utilidades/orden.class';
import { ESTADOS_ORDEN_PREPARADA } from 'src/app/ordenes/utilidades/ordenes.static';
import {
  EstadoOrden,
  TipoPreparacion,
} from 'src/app/ordenes/utilidades/ordenes.models';
import { EstadoDomicilio } from 'src/app/domicilios/utilidades/domicilios.models';
import {
  FORMATO_FECHA_PIPE_2,
  Icono,
} from 'src/app/compartido/utilidades/compartido.static';
import { Domicilio } from 'src/app/domicilios/utilidades/domicilio.class';
import {
  ESTADOS_DOMICILIO_COMPLETADO,
  ESTADOS_DOMICILIO_DESPACHADO,
  ESTADOS_DOMICILIO_FALLIDO,
  ESTADOS_DOMICILIO_RUTA,
} from 'src/app/domicilios/utilidades/domiclios.static';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { OrdenesService } from '../../utilidades/ordenes.service';
import { ErrorFrontend } from 'src/app/compartido/utilidades/error.utils';
import { AlertasService } from 'src/app/nucleo/utilidades/alertas.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomiciliosService } from 'src/app/domicilios/utilidades/domicilios.service';

@Component({
  selector: 'ordenes-historial-orden',
  templateUrl: './historial-orden.component.html',
  styleUrl: './historial-orden.component.scss',
  standalone: true,
  imports: [MatIconModule, CommonModule, MatProgressSpinnerModule],
})
export class HistorialOrdenComponent implements OnInit {
  /* ID de la orden */
  @Input({ required: true }) idOrden!: number;

  /* Orden */
  protected orden: Orden | undefined;

  /* Domicilio */
  protected domicilios: (Domicilio | undefined)[] = [];

  /* Emisores de eventos */
  @Output() public cerrar = new EventEmitter<void>();

  /* Estado de carga */
  protected cargando = signal<boolean>(true);

  constructor(
    private readonly _ordenesService: OrdenesService,
    private readonly _domiciliosService: DomiciliosService,
    private readonly _alertasService: AlertasService,
  ) {}

  /* Constantes */
  protected readonly Icono = Icono;
  protected readonly EstadoOrden = EstadoOrden;
  protected readonly EstadoDomicilio = EstadoDomicilio;
  protected readonly TipoPreparacion = TipoPreparacion;
  protected readonly FORMATO_FECHA_PIPE_2 = FORMATO_FECHA_PIPE_2;
  protected readonly ESTADOS_ORDEN_PREPARADA = ESTADOS_ORDEN_PREPARADA;
  protected readonly ESTADOS_DOMICILIO_RUTA = ESTADOS_DOMICILIO_RUTA;
  protected readonly ESTADOS_DOMICILIO_DESPACHADO =
    ESTADOS_DOMICILIO_DESPACHADO;
  protected readonly ESTADOS_DOMICILIO_COMPLETADO =
    ESTADOS_DOMICILIO_COMPLETADO;
  protected readonly ESTADOS_DOMICILIO_FALLIDO = ESTADOS_DOMICILIO_FALLIDO;

  ngOnInit(): void {
    this.cargando.set(true);

    // Obtener la orden
    this._ordenesService
      .obtenerOrden$(this.idOrden)
      .then((orden: Orden) => {
        // Asignar la orden
        this.orden = orden;

        // Obtener los domicilios de la orden
        if (orden.domicilio) {
          this.domicilios = [orden.domicilio];
          if (orden.domicilio.antecesor)
            this._agregarAntecesor(orden.domicilio.antecesor);
        } else this.domicilios = [undefined];

        this.cargando.set(false);
      })
      .catch((error: ErrorFrontend) => {
        this._alertasService.alertarError('Error: ' + error.message);
        this.cargando.set(false);
      });
  }

  /**
   * Agrega un domicilio antecesor a la lista de domicilios.
   * @param {number} idDomicilio - ID del domicilio a agregar.
   * @author Juan Corral
   */
  private _agregarAntecesor(idDomicilio: number): void {
    this._domiciliosService
      .obtenerDomicilio$(idDomicilio)
      .then((domicilio: Domicilio) => {
        this.domicilios.unshift(domicilio);
        if (domicilio.antecesor) this._agregarAntecesor(domicilio.antecesor);
      })
      .catch((error: ErrorFrontend) => {
        this._alertasService.alertarError('Error: ' + error.message);
      });
  }
}
